import React, { useEffect, useState } from "react";
import cn from "classnames";

import { Popover } from "@litres/ui-kit/popover";

import { MyBooksMenu } from "./MyBooksMenu/MyBooksMenu";
import { useGetUserMonetizationData } from "../../hooks/useGetUserMonetizationData";
import type { IMyBooksProps } from "../../utils/types";
import { EPopups } from "../../utils/enums";
import { Tab } from "../Tab";

import styles from "./MyBooks.module.scss";

export const MyBooks = (props: IMyBooksProps) => {
  const { isUserAnonymous, isLibrary, openedPopup, setOpenedPopup } = props;
  const [isMenuOpen, setMenuVisibility] = useState<boolean>(false);
  const [isMyBooksLoading, _setMyBooksLoading] = useState<boolean>(false);

  const { data: userMonetizationData } = useGetUserMonetizationData();

  useEffect(() => {
    if (isMenuOpen && openedPopup !== EPopups.MyBooks) {
      setMenuVisibility(false);
    }
  }, [openedPopup, isMenuOpen]);

  const handleVisibilityChange = (visibility: boolean): void => {
    setMenuVisibility(visibility);
    if (visibility) {
      setOpenedPopup(EPopups.MyBooks);
    }
  };

  return (
    <Popover
      placement="bottom"
      trigger="hover"
      disableArrow
      offset={[8, 0]}
      padding={{ right: 24 }}
      portal={false}
      content={
        <MyBooksMenu isLibrary={isLibrary} isUserAnonymous={isUserAnonymous} />
      }
      contentClassName={styles.popoverContent}
      visible={isMenuOpen}
      onVisibleChange={handleVisibilityChange}
      closeOnClick={false}
    >
      <Tab
        type="myBooks"
        count={userMonetizationData?.bought_collections.length}
        classNames={[
          cn({ [styles.newClickedWrapper]: isMenuOpen || isMyBooksLoading }),
        ]}
      />
    </Popover>
  );
};
